export default (url) => {
  try {
    return new URL(url).pathname;
  } catch (e) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (err) {
      // ignore
    }
  }
  return url;
};
